import React from "react";
import "./index.css";

import {createSearchParams} from "react-router-dom";
import Sidebar from "../../../components/Sidebar";
import TableHeader from "../../../components/TableHeader";
import PageHeader from "../../../components/PageHeader";
import moment from "moment";
import Pagination from "../../../components/Pagination";
import LinkPlus from "../../../components/Link/LinkPlus";
import {getSchoolId, getSchoolYear, setAccessToken} from "../../../utils/authority";
import ClassRoomController from "../../../services/data-declaration/class-room-controller";
import vi from "date-fns/locale/vi";
import DatePicker, {registerLocale} from "react-datepicker";
import PublicSecureAuthorization from "../../../services/system/secure-authorization/secure-authorization-controller";
import NotiController from "../../../services/system/noti/noti-controller";
import ModalDeleteService from "./modalDeleteService";
import ParentsController from "../../../services/parents";
import AdSchoolInfoManager from "../../../services/system/school-info/ad-school-info-manager";
import {toast} from "react-toastify";
import AdminController from "../../../services/system/admin-controller";
import GradeManager from "../../../components/Grade";
registerLocale("vi", vi);


class ParentsManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            listSchool: [],
            yearId: parseInt(getSchoolYear()),
            schoolId: 0,
            status: "",
            phone: "",
            fullName: "",
            sort: 'created_at desc',
            title: "",

            typeStr: "",
            startDate: null,
            endDate: null,
            recipientId: -1,
            pageNumber: 0,
            pageSize: 10,
            groupId: -1,


            listGroupUser: [],
            listData: [],
            listClassRoom: [],

            classRoomId: -1,
            gradeId: "",
            totalItem: 0,
            header: [
                {
                    id: "123",
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "name",
                    name: "Tên phụ huynh",
                    style: {textAlign: "left"},
                    sort: false
                },
                {
                    id: "username",
                    name: "Số điện thoại",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "email",
                    name: "Email",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "child",
                    name: "Danh sách con",
                    style: {textAlign: "center"},
                    sort: false
                },
                {
                    id: "state",
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false
                }
            ]
        };
    }
    componentWillMount() {
        this.getListSchool()
        this.getListParents()
    }
    getListSchool = () => {
        let payload = {
            pageNumber: 0,
            pageSize: 1000,
            sort: this.state.sort,
        };
        AdSchoolInfoManager.getListSchool(payload, res => {
            if (res.success) {
                this.setState({
                    listSchool: res.data.content,
                });
            }else {
                toast.error("Có lỗi xảy ra!", {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 3000
                });
            }
        })
    };
    handleChangePage = page => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.getListParents();
            }
        );
    };
    getListClass() {
        let payload = {
            yearId: parseInt(getSchoolYear()),
            grade: this.state.gradeId,
            name: "",
            pageNumber: 0,
            pageSize: 200,
            sort: "created_at desc"
        };
        ClassRoomController.search(payload, res => {
            this.setState({
                showLoading: false,
                listClassRoom: res.data.content,
            });
        })
    }
    getListParents() {
        let payload = {
            schoolId: this.state.schoolId,
            phone: this.state.phone,
            status: this.state.status,
            fullName: this.state.fullName,
            classRoomId:  this.state.classRoomId,
            pageNumber: this.state.pageNumber,
            pageSize: this.state.pageSize,
            sort: "created_at desc",
        };
        ParentsController.search(payload, res => {
            this.setState({
                showLoading: false,
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize)
            });
        })
    }
    selectSchool = () => {
        // AdminController.selectSchool(parseInt(this.state.schoolId), res => {
        //     if (res.success) {
        //         let day = this.state.remember ? 7 : 1;
        //         setAccessToken(res.data, day);
        //     }else {
        //         toast.error("Có lỗi xảy ra!", {
        //             position: toast.POSITION.TOP_RIGHT,
        //             autoClose: 3000
        //         });
        //     }
        //     window.location.reload();
        // })
    };
    onhandleSearch() {
        this.getListParents()
    }
    renderClassRoom = () => {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    };
    onUpdateGrade(gradeId){
        this.setState({
            gradeId: gradeId
        }, ()=>{
            this.getListClass()
        });
    }
    renderClass() {
        return this.state.listClassRoom.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderStatus() {
        let listStatus = [
            {
                "id": "ACTIVE",
                "name": "Hoạt động"
            },
            {
                "id": "INACTIVE",
                "name": "Chưa kích hoạt"
            },
            {
                "id": "LOCK",
                "name": "Khóa"
            }
        ]
        return listStatus.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    renderSchool() {
        return this.state.listSchool.map((item, index) => <option
            value={item.id}>{item.name}</option>)
    }
    getState(state) {
        if (state == "PUBLISH")
            return "Đã phát hành"
        else if (state == "PENDING")
            return "Chờ phát hành"
        else
            return "Đã khóa"
    }
    getListGroupUser() {
        PublicSecureAuthorization.getListRoles(res => {
            if (res.success) {
                let data = res.data.content;
                this.setState(
                    {
                        listGroupUser: res.data.content
                    }
                );
            } else {
            }
        });
    }
    render() {
        let {listData, header, gradeId} = this.state
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="phu-huynh-management"/>
                        <div className="col-md-10 tab-content with-loading">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className="pt-3 mb-2">
                                    <PageHeader routerEnable={true} title="Quản lý phụ huynh"/>
                                    <form className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Tên phụ huynh</label>
                                                <input
                                                    placeholder="Nhập tên phụ huynh"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.title}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({title: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Số điện thoại</label>
                                                <input
                                                    placeholder="Nhập SĐT phụ huynh"
                                                    name="title"
                                                    type="text"
                                                    className="form-control shadow-none font-14"
                                                    style={{width: "100%", height: 35, padding: 8}}
                                                    value={this.state.phone}
                                                    maxLength={50}
                                                    onKeyPress={(e) => {
                                                        if (e.key === 'Enter') {
                                                            this.onhandleSearch()
                                                        }
                                                    }}
                                                    onChange={val =>
                                                        this.setState({phone: val.target.value.trim()})
                                                    }
                                                />
                                            </div>
                                            {/*<div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex">*/}
                                            {/*    <label className="label-item col-md-4">Trường học</label>*/}
                                            {/*    <select*/}
                                            {/*        className="form-control kt-input pd-4-input hei-input"*/}
                                            {/*        value={this.state.schoolId}*/}
                                            {/*        onChange={(e) => {*/}
                                            {/*            this.state.schoolId = e.target.value;*/}
                                            {/*            this.setState({*/}
                                            {/*                schoolId: e.target.value*/}
                                            {/*            }, ()=>{*/}
                                            {/*                this.getListParents()*/}
                                            {/*            })*/}
                                            {/*        }}*/}
                                            {/*    >*/}
                                            {/*        <option*/}
                                            {/*            value="0">Tất cả</option>*/}
                                            {/*        {this.renderSchool()}*/}
                                            {/*    </select>*/}
                                            {/*</div>*/}
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-0 pr-md-3 d-flex">
                                                <label className="label-item col-md-4">Trạng thái</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.status}
                                                    onChange={(e) => {
                                                        this.state.status = e.target.value;
                                                        this.setState({
                                                            status: e.target.value
                                                        })
                                                    }}
                                                >
                                                    <option value="">Tất cả</option>
                                                    {this.renderStatus()}
                                                </select>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Khối</label>
                                                <GradeManager
                                                    gradeId={gradeId}
                                                    onUpdateGrade={(gradeId) => this.onUpdateGrade(gradeId)}
                                                />
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 p-1 pr-md-3 d-flex">
                                                <label className="col-md-4 label-item pl-0">Lớp</label>
                                                <select
                                                    className="form-control kt-input pd-4-input hei-input"
                                                    value={this.state.classRoomId}
                                                    onChange={(e) => {
                                                        this.state.classRoomId = e.target.value;
                                                        this.setState({
                                                            classRoomId: e.target.value,
                                                            inEditing: true
                                                        }, () =>{
                                                            this.getListParents()
                                                        })
                                                    }}
                                                >
                                                    <option value="-1">Chọn lớp</option>
                                                    {this.renderClassRoom()}
                                                </select>
                                            </div>

                                            <div className="col-xs-12 col-sm-12 col-md-12 p-1 pr-md-3 d-flex" style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "center"
                                            }}>
                                                <button
                                                    style={{height: 35}}
                                                    type="button"
                                                    className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"
                                                    onClick={() => this.onhandleSearch()}
                                                >
                                                    Tìm kiếm
                                                </button>
                                            </div>

                                            {/*<div className="col-xs-12 col-sm-12 col-md-12 p-0 pr-md-3 d-flex"*/}
                                            {/*     style={{*/}
                                            {/*         alignItems: "center",*/}
                                            {/*         justifyContent: "right"*/}
                                            {/*     }}>*/}

                                            {/*    <button*/}
                                            {/*        style={{height: 35, marginRight: 12}}*/}
                                            {/*        type="button"*/}
                                            {/*        className="border-1-s background-btn type-button-fix btn btn-primary btn-sm"*/}
                                            {/*        onClick={() => this.setState({showModalCreate: true})}*/}
                                            {/*    >*/}
                                            {/*        Xuất Excell*/}
                                            {/*    </button>*/}
                                            {/*</div>*/}
                                        </div>
                                    </form>
                                </div>
                                <div className="p-0 mb-3">
                                    <div className="table-wrapper">
                                        <table
                                            className="table table-striped table-data table-responsive table-bordered">
                                            <table className="table">
                                                <thead>
                                                <TableHeader
                                                    header={header}
                                                />
                                                </thead>
                                                {!this.state.listData ||
                                                this.state.listData.length == 0 ? (
                                                    <tbody>
                                                    <tr>
                                                        <td colSpan={12}>
                                                            <div className="text-center">
                                                                Không có dữ liệu
                                                            </div>
                                                        </td>
                                                    </tr>
                                                    </tbody>
                                                ) : (
                                                    <tbody>
                                                    {listData &&
                                                    listData.length > 0 &&
                                                    listData?.map((row, index) => (
                                                        <tr style={{height: 50}}>
                                                            <td style={{textAlign: "center"}} scope="row">
                                                                {" "}
                                                                {this.state.pageNumber * this.state.pageSize +
                                                                index +
                                                                1}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.fullName}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.phone}
                                                            </td>
                                                            <td style={{textAlign: "left"}} scope="row">
                                                                {row.email}
                                                            </td>
                                                            <td style={{textAlign: "center", display: "grid"}}>
                                                                {
                                                                    row.studentsRes.length > 0 &&
                                                                    row.studentsRes.map((student, index) =>
                                                                    <LinkPlus
                                                                        style={{color: '#0018ff'}}
                                                                        to={{
                                                                            pathname: "/ad-sas-school/sua-ho-so-hoc-sinh",
                                                                            search: createSearchParams({
                                                                                id: `${student.id}`
                                                                            }).toString(),
                                                                            state: {
                                                                                id: student.id
                                                                            }
                                                                        }}
                                                                    >
                                                                        {student.fullName}-{student.currentClassRoomRes["name"]}
                                                                    </LinkPlus>)
                                                                }
                                                                {
                                                                    row.studentsRes.length < 1 &&
                                                                    "Chưa liên kết"
                                                                }
                                                            </td>
                                                            <td style={{textAlign: "center"}}>
                                                                {row.status=="INACTIVE" ? <span className="badge badge-warning" style={{color: "white"}}>Chưa kích hoạt</span> : row.status=="ACTIVE"?<span className="badge badge-success" style={{color: "white"}}>Hoạt động</span>:<span className="badge badge-danger" style={{color: "white"}}>Khó</span>}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                )}
                                            </table>
                                        </table>
                                    </div>
                                    <div className="pagination-right">
                                        <Pagination
                                            activePage={this.state.pageNumber}
                                            itemsCountPerPage={this.state.pageSize}
                                            totalItemsCount={this.state.totalItem}
                                            changeHandler={page => this.handleChangePage(page)}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDeleteService
                    show={this.state.showModalDelete}
                    onHide={() => this.setState({showModalDelete: false})}
                    onRefresh={() => this.onhandleSearch()}
                    id={this.state.itemSelected}
                />
            </div>
        );
    }
}

export default ParentsManagement;
